/*
 * Tunisia's 24 governorates and the ONAT bar levels, in the three site
 * languages. Shared by the API (page renderer, sitemaps, ONAT import) and the
 * UI (bundled through a webpack alias), so both build identical URLs.
 *
 * Plain CommonJS with no dependencies: it runs in node and in the browser.
 */

// key: stable latin identifier, also the fr/en URL segment.
// fr/en: display names. ar: display name; its URL segment is the slug of it.
// aliases: spellings found in existing data (stateInFrench / stateInArabic).
const GOVERNORATES = [
  { key: "tunis", ar: "تونس", fr: "Tunis", en: "Tunis", aliases: [] },
  { key: "ariana", ar: "أريانة", fr: "Ariana", en: "Ariana", aliases: [] },
  { key: "ben-arous", ar: "بن عروس", fr: "Ben Arous", en: "Ben Arous", aliases: [] },
  { key: "manouba", ar: "منوبة", fr: "Manouba", en: "Manouba", aliases: ["Mannouba", "La Manouba"] },
  { key: "nabeul", ar: "نابل", fr: "Nabeul", en: "Nabeul", aliases: [] },
  { key: "zaghouan", ar: "زغوان", fr: "Zaghouan", en: "Zaghouan", aliases: [] },
  { key: "bizerte", ar: "بنزرت", fr: "Bizerte", en: "Bizerte", aliases: [] },
  { key: "beja", ar: "باجة", fr: "Béja", en: "Beja", aliases: [] },
  { key: "jendouba", ar: "جندوبة", fr: "Jendouba", en: "Jendouba", aliases: [] },
  { key: "kef", ar: "الكاف", fr: "Le Kef", en: "Kef", aliases: ["El Kef", "Kef"] },
  { key: "siliana", ar: "سليانة", fr: "Siliana", en: "Siliana", aliases: [] },
  { key: "sousse", ar: "سوسة", fr: "Sousse", en: "Sousse", aliases: [] },
  { key: "monastir", ar: "المنستير", fr: "Monastir", en: "Monastir", aliases: [] },
  { key: "mahdia", ar: "المهدية", fr: "Mahdia", en: "Mahdia", aliases: [] },
  { key: "sfax", ar: "صفاقس", fr: "Sfax", en: "Sfax", aliases: [] },
  { key: "kairouan", ar: "القيروان", fr: "Kairouan", en: "Kairouan", aliases: [] },
  { key: "kasserine", ar: "القصرين", fr: "Kasserine", en: "Kasserine", aliases: [] },
  { key: "sidi-bouzid", ar: "سيدي بوزيد", fr: "Sidi Bouzid", en: "Sidi Bouzid", aliases: [] },
  { key: "gabes", ar: "قابس", fr: "Gabès", en: "Gabes", aliases: [] },
  { key: "medenine", ar: "مدنين", fr: "Médenine", en: "Medenine", aliases: [] },
  { key: "tataouine", ar: "تطاوين", fr: "Tataouine", en: "Tataouine", aliases: [] },
  { key: "gafsa", ar: "قفصة", fr: "Gafsa", en: "Gafsa", aliases: [] },
  { key: "tozeur", ar: "توزر", fr: "Tozeur", en: "Tozeur", aliases: [] },
  { key: "kebili", ar: "قبلي", fr: "Kébili", en: "Kebili", aliases: [] },
];

// ONAT "tableau": which courts a lawyer may plead before.
// key doubles as the stored barLevel value.
const BAR_LEVELS = [
  {
    key: 1,
    slug: { ar: "متربص", fr: "stagiaire", en: "trainee" },
    ar: "محامٍ متربص",
    fr: "Avocat stagiaire",
    en: "Trainee lawyer",
    plural: { ar: "المحامون المتربصون", fr: "Avocats stagiaires", en: "Trainee lawyers" },
  },
  {
    key: 2,
    slug: { ar: "استئناف", fr: "appel", en: "appeal" },
    ar: "محامٍ لدى الاستئناف",
    fr: "Avocat près la Cour d'appel",
    en: "Court of Appeal lawyer",
    plural: { ar: "المحامون لدى الاستئناف", fr: "Avocats près la Cour d'appel", en: "Court of Appeal lawyers" },
  },
  {
    key: 3,
    slug: { ar: "تعقيب", fr: "cassation", en: "cassation" },
    ar: "محامٍ لدى التعقيب",
    fr: "Avocat près la Cour de cassation",
    en: "Court of Cassation lawyer",
    plural: { ar: "المحامون لدى التعقيب", fr: "Avocats près la Cour de cassation", en: "Court of Cassation lawyers" },
  },
];

module.exports = { GOVERNORATES, BAR_LEVELS };
